import React from "react";
import "./CeLogin.css";
import { withRouter } from "react-router-dom";
import withSnackbar from "../../util/withSnackbar";
import { GREEN_SNACKBAR_OPTIONS, TUTORIALS_LINK } from "../../constants/CommonConstants";
import { injectIntl } from "react-intl";
import Header from "../CeHeader/Header";
import { LinearProgress } from '@mui/material';
import Button from '@mui/material/Button';
import _ from 'lodash';
import cognitoAuth from '../../util/Cognito';
import ReactPiwik from 'react-piwik';
import { checkRevision } from '../../Common/revisionCheck';
import queryString from 'query-string';
import ForgetPasswordDialog from "./ForgetPasswordDialog";
import ResetPasswordDialog from "./ResetPasswordDialog";
import PendingVerificationDialog from './PendingVerificationDialog';
import { Link } from 'react-router-dom';
import { ResetPW } from "../../util/util";

class CeLogin extends React.Component {

    constructor(props) {
        super(props);
        this.handleKeyDown = this.handleKeyDown.bind(this);
        this.state = {
            isLoginError: false,
            isNetworkError: false,
            isProgress: false,
            forgetPasswordDialog: false,
            pendingVerificationDialog: false,
            resetPasswordDialog: queryString.parse(window.location.search).forcePasswordChange === ResetPW,
        };
        this.displaySnackbar = this.displaySnackbar.bind(this);
    };

    signInCognito = async () => {
        this.setState({isProgress:true});
        checkRevision().then( async () => {
            await cognitoAuth.signIn(this.state.ceId, this.state.password)
                .then(async () => {
                    // 行動ログ分析トレースポイント
                    if (process.env.REACT_APP_BUILD_ENV === 'prod') {
                        ReactPiwik.push(['trackEvent', 'loginUser', this.state.ceId]);
                    }
                    this.setState({ isLoginError: false });
                    let header = {
                        'Authorization': '',
                        'Content-Type': 'application/json'
                    };

                    cognitoAuth.getAuthorizationToken().then((token) => {
                        header.Authorization = token;
                    }, () => {
                        this.setState({ isProgress: false });
                        this.props.history.push({
                            pathname: '/',
                        });
                    }).then(() => {
                        this.updateAccount(header);
                    });
                }).catch(async (e) => {
                    //前のエラーを消す
                    this.setState({ 
                        isLoginError: false,
                        isNetworkError: false,
                        isProgress: false,
                        isTokenError: false
                    });
                    if (e.code === "NetworkError") {
                        this.setState({ isNetworkError: true });
                    } else {
                        this.setState({ isLoginError: true });
                    }
                });
        });
    };

    updateAccount(header) {
        fetch(process.env.REACT_APP_CE_ACCOUNT, {
            method: "PUT",
            headers: header,
            body: JSON.stringify({
                authToken: queryString.parse(window.location.search).tkn,
            }),
        }).then(res => {
            if (!res.ok) {
                this.setState({ isTokenError: true });
                res.text().then((text) => {
                    let res_obj = JSON.parse(text);
                    if (res_obj.status === 403 && res_obj.code === "PendingState") {
                        // 対象ユーザーのステータスが'pending'かつauthTokenが空であれば確認メール送付モーダルを表示する
                        this.setState({ pendingVerificationDialog: true });
                        return;
                    }
                });
            } else {
                cognitoAuth
                    .getAuthorizationToken()
                    .then(
                    (token) => {
                        localStorage.setItem("ceAuthorization",token)
                    },
                    (error) => {
                        throw error;
                    }
                )
                localStorage.setItem("ceUserId",cognitoAuth.getUserName())
                this.gotoTop();
            }
        }).catch((e) => {
            throw e;
        }).finally(() => {
            this.setState({isProgress:false});
        });
    }
    
    gotoTop() {
        try {
            this.props.history.push({
                pathname: '/ce/top',
                state: {
                    ceId: this.state.ceId
                }
            });
        } catch (e) {
            this.setState({ 
                isLoginError: true,
                isNetworkError: false,
                isTokenError: false
            });
        }
    }

    forgetPassword(){
        this.props.history.push({
            pathname: '/ce/forgetPassword',
            state:{
                originPath: '/'
            }
        });
    }

    createAccount(){
        console.log('createAccount', this.props);
        this.props.history.push({
            pathname: '/ce/createAccount'
        });
    }

    privacyStatement(){
        this.props.history.push({
            pathname: '/ce/privacyStatement'
        });
    }

    handleKeyDown(e) {
        // Enter の場合のみ
        if (e.which === 13) {
            this.signInCognito();
        }
    }

    displaySnackbar = (param) => {
        switch (param) {
            case 'forget':
                this.props.openSnackbar('メールを送信しました');
                break;
            case 'reset':
                this.props.openSnackbar('パスワード変更が完了しました');
                break;
            case 'pending':
                this.props.openSnackbar('確認メールの再送を行いました');
                break;
            default:
                break;
        }
    };
    linkToTutorialSite = () => {
        const tutorialsLink = TUTORIALS_LINK[process.env.REACT_APP_BUILD_ENV];
        window.open(tutorialsLink, "_blank");
    };

    render() {
        // localStorageに言語設定がない場合は英語をデフォルトとする
        const lang = !localStorage.getItem('lang') ? 'en' : localStorage.getItem('lang');

        return (
            <div id="ceLogin">
                <div id="wrapper">
                    {this.state.isProgress ? <LinearProgress /> : ''}
                    <Header showSubMenu={false} />

                    <div className="contentsWrapper show">
                        <div className={this.props.curScreenWidth < 1920 ? "contents contents-downLarge" : "contents"}>
                            <div className="loginTitle" >
                                <div className="mainTitle">
                                    <span>{this.props.intl.formatMessage({ id: "application_title" })}</span>
                                </div>
                                <div className="subTitle">
                                    <span>{this.props.intl.formatMessage({ id: "ce_application_sub_title" })}</span>
                                </div>
                            </div>
                            
                            <div className="formWrapper">
                                <div className="form">
                                    <div className="label mgTop">
                                        <span>{this.props.intl.formatMessage({ id: "language" })}</span>
                                    </div>
                                    <div className="inputField">
                                        <select defaultValue={lang} exclusive onChange={e => this.props.updateLang(e.target.value)}>
                                            {/* 英語/日本語だけ残す、ほかの言語は販売状況により復活可能性あるため、一旦コメントアウト */}
                                            <option value="en">{"English"}</option>
                                            {/* <option value="fr">{"Français"}</option>
                                            <option value="de">{"Deutsch"}</option>
                                            <option value="it">{"Italiano"}</option> */}
                                            <option value="ja">{"日本語"}</option>
                                            {/* <option value="es">{"Español"}</option> */}
                                        </select>
                                    </div>

                                    <div className={this.props.curScreenWidth < 1920 ? "inputFieldGroup-downLarge" : "inputFieldGroup"}>
                                        <div className="label">
                                            <span>
                                                {this.props.intl.formatMessage({
                                                    id: "username_email",
                                                })}
                                            </span>
                                        </div>
                                        <div className="inputField">
                                            <input 
                                                type="text" 
                                                name="name" 
                                                size="30" 
                                                maxLength="128" 
                                                onChange={event => _.assign(this.state, { ceId: event.target.value })} 
                                                onKeyPress={this.handleKeyDown}/>
                                        </div>

                                        <div className="label mgT">
                                            <span>
                                                {this.props.intl.formatMessage({
                                                    id: "user_password",
                                                })}
                                            </span>
                                        </div>
                                        <div className="inputField password">
                                            <input 
                                                type="password" 
                                                name="pass" 
                                                size="30" 
                                                maxLength="40" 
                                                onChange={event => _.assign(this.state, { password: event.target.value })}  
                                                onKeyPress={this.handleKeyDown}/>
                                        </div>
                                        
                                        <div className="checkBox" >
                                            <span className="disabledCursor link" onClick={() => this.setState({forgetPasswordDialog: true})}>
                                                <Link to="" className="disabledCursor link">
                                                    {this.props.intl.formatMessage({ id: "login_forgot_password" })}
                                                </Link>
                                            </span>
                                        </div>
                                        
                                        

                                        <div className={this.props.curScreenWidth < 1920 ? "links-tutorial-downLarge" : "links-tutorial"}>
                                            <span fullWidth onClick={()=> this.linkToTutorialSite()}>
                                                <Link to="/" className="disabledCursor link">
                                                    {this.props.intl.formatMessage({ id: "ce_login_tutorial" })}
                                                </Link>
                                            </span>
                                        </div>
                                    </div>

                                    <div className="submit_login">
                                        <Button
                                            sx={{ fontSize: "14px" }}
                                            fullWidth
                                            id="loginButton"
                                            onClick={() => this.signInCognito()}
                                        >
                                            {this.props.intl.formatMessage({ id: "sign_in" })}
                                        </Button>
                                    </div>
                                </div>
                                <div className={this.props.curScreenWidth < 1920 ? "errMsg-downLarge" : "errMsg"}>{this.state.isLoginError ? <span>{this.props.intl.formatMessage({ id: "sign_in_error" })}</span> : null}</div>
                                <div className={this.props.curScreenWidth < 1920 ? "errMsg-downLarge" : "errMsg"}>{this.state.isTokenError ? <span>{this.props.intl.formatMessage({ id: "errCode_10007" })}</span> : null}</div>
                                <div className={this.props.curScreenWidth < 1920 ? "errMsg-downLarge" : "errMsg"}>{this.state.isNetworkError ? <span>{this.props.intl.formatMessage({ id: "errCode_10006" })}</span> : null}</div>
                            </div>

                            <div className="footButton">
                                <div className="create_account">
                                    <Button fullWidth id="createAccountButton" onClick={() => this.createAccount()}>
                                        {this.props.intl.formatMessage({ id: "create_account" })}
                                    </Button>
                                </div>
                                <div className="links-privacyStatement">
                                    <span fullWidth onClick={() => this.privacyStatement()}>
                                        <Link to="/" className="disabledCursor link">
                                            {this.props.intl.formatMessage({ id: "privacy_statement" })}
                                        </Link>
                                    </span>
                                </div>
                            </div>
                        </div>
                        
                        <div className="companyLogo">
                            <img src="/assets/img/km_logo.svg" alt="km_logo" />
                        </div>
                    </div>
                </div>
                <ForgetPasswordDialog show={this.state.forgetPasswordDialog} handleClose={() => {this.setState({forgetPasswordDialog: false})}} displaySnackbar={this.displaySnackbar.bind(this, 'forget')} intl={this.props.intl} callback={this.sessionTimeout} httpError={this.httpError} />
                <ResetPasswordDialog show={this.state.resetPasswordDialog} handleClose={() => {this.setState({resetPasswordDialog: false})}} displaySnackbar={this.displaySnackbar.bind(this, 'reset')} intl={this.props.intl} callback={this.sessionTimeout} httpError={this.httpError} />
                <PendingVerificationDialog show={this.state.pendingVerificationDialog} handleClose={() => {this.setState({pendingVerificationDialog: false})}} displaySnackbar={this.displaySnackbar.bind(this, 'pending')} intl={this.props.intl} ceId={this.state.ceId} />
        </div>
        );
    }
}

export default withSnackbar(withRouter(injectIntl(CeLogin)), GREEN_SNACKBAR_OPTIONS);
